import * as React from 'react';
import { createSvgIcon } from '@mui/material';
var DoNotPopulateEmpty = createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  version: "1.1"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.08991667,-0.000166666672 L16.7824167,15.6923333 L15.6924167,16.7823333 L12.3865833,13.4765 L12.3865833,14.119 L10.9974167,14.119 L10.9974167,12.7298333 L11.6399167,12.7298333 L4.05241667,5.14233333 L4.05241667,5.78483333 L2.66325,5.78483333 L2.66325,4.39566667 L3.30575,4.39566667 L-8.3333334e-05,1.08983333 L1.08991667,-0.000166666672 Z M6.83083333,12.72975 L6.83083333,14.1189167 L5.44166667,14.1189167 L5.44166667,12.72975 L6.83083333,12.72975 Z M4.05208333,12.7296667 L4.05208333,14.1188333 C3.28791667,14.1188333 2.66291667,13.4938333 2.66291667,12.7296667 L2.66291667,12.7296667 L4.05208333,12.7296667 Z M9.60833333,12.72975 L9.60833333,14.1189167 L8.21916667,14.1189167 L8.21916667,12.72975 L9.60833333,12.72975 Z M15.1641667,9.95175 L15.1641667,11.3409167 L14.5616667,11.3409167 L13.775,10.55425 L13.775,9.95175 L15.1641667,9.95175 Z M4.0525,9.95141667 L4.0525,11.3405833 L2.66333333,11.3405833 L2.66333333,9.95141667 L4.0525,9.95141667 Z M4.0525,7.17391667 L4.0525,8.56308333 L2.66333333,8.56308333 L2.66333333,7.17391667 L4.0525,7.17391667 Z M15.1641667,7.17391667 L15.1641667,8.56308333 L13.775,8.56308333 L13.775,7.17391667 L15.1641667,7.17391667 Z M15.1641667,4.39558333 L15.1641667,5.78475 L13.775,5.78475 L13.775,4.39558333 L15.1641667,4.39558333 Z M13.7754167,1.618 C14.5395833,1.618 15.1645833,2.243 15.1645833,3.00716667 L15.1645833,3.00716667 L13.7754167,3.00716667 Z M12.3866667,1.61808333 L12.3866667,3.00725 L10.9975,3.00725 L10.9975,1.61808333 L12.3866667,1.61808333 Z M9.60833333,1.61808333 L9.60833333,3.00725 L8.21916667,3.00725 L8.21916667,1.61808333 L9.60833333,1.61808333 Z M6.83041667,1.61766667 L6.83041667,3.00683333 L6.22791667,3.00683333 L5.44125,2.22016667 L5.44125,1.61766667 L6.83041667,1.61766667 Z",
  id: "doNotPopulateEmpty-path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "doNotPopulateEmpty-Map-Data",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "doNotPopulateEmpty-Map-Data-on-focus_no-mapping",
  transform: "translate(-1222.000000, -591.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "doNotPopulateEmpty-Group-13",
  transform: "translate(582.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "doNotPopulateEmpty-Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_IgnorefEmpty",
  transform: "translate(639.000000, 228.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "doNotPopulateEmpty-\uD83C\uDFA8-Color",
  transform: "translate(1.666667, 1.666667)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "doNotPopulateEmpty-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  href: "#doNotPopulateEmpty-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#616161",
  href: "#doNotPopulateEmpty-path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Colors/Dark-Gray",
  mask: "url(#doNotPopulateEmpty-mask-2)",
  fill: "#616161"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12.500000, -12.500000)",
  id: "doNotPopulateEmpty-Rectangle-Copy-29"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "41.6666667",
  height: "41.6666667"
})))))))))), 'DoNotPopulateEmpty');
export { DoNotPopulateEmpty };